import script from "./BaseNavList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseNavList.vue?vue&type=script&setup=true&lang=ts"

import "./BaseNavList.vue?vue&type=style&index=0&id=252b5065&lang=scss"

const __exports__ = script;

export default __exports__